import { Bone, SkeletonGrid, SkeletonStatTile } from '../primitives';

// Matches Overview.js's real layout: 7 stat tiles, a trend chart, then 4 pie-chart cards.
export default function AnalyticsOverviewSkeleton() {
    return (
        <div>
            <SkeletonGrid cols={4} gap={12}>
                {Array.from({ length: 7 }).map((_, i) => <SkeletonStatTile key={i} />)}
            </SkeletonGrid>
            <Bone h={260} r={12} style={{ margin: '16px 0' }} />
            <SkeletonGrid cols={4} gap={12}>
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} style={{ border: '1px solid #E2E8F0', borderRadius: 12, padding: 14 }}>
                        <Bone h={10} w="60%" style={{ marginBottom: 10 }} />
                        <Bone h={120} r={999} />
                    </div>
                ))}
            </SkeletonGrid>
        </div>
    );
}
